import moment from "moment";
import { useCallback, useContext } from "react";
import { RillContext } from "../../../../rill/RillReact/share/base";
import convertToRiR from "../../../../utils/converters/convert-intensity";

const MINUS = "−";

// "+1.2", "−0.7" or "0.0": a change that rounds to nothing carries no sign
export const formatChange = (change) => {
  if (change === 0) return "0.0";
  return change > 0
    ? `+${change.toFixed(1)}`
    : `${MINUS}${Math.abs(change).toFixed(1)}`;
};

// A range that is one value wide (a client who always answers the same) is that value, not "4–4"
export const isSingleValue = (range) => range.lo === range.hi;

// A YYYYMMDD day as text: "Mar 5, 2026" by default, or any moment pattern
export const formatUtcDay = (utcDate, pattern = "MMM D, YYYY") =>
  moment(String(utcDate), "YYYYMMDD").format(pattern);

// The athlete picks RPE or RiR (Session RPE report does the same); the stored value is always RPE.
// `context` makes i18next read the "_rir" variant of a key, `toMeasure` converts a stored value.
export const useIntensity = () => {
  const { locals } = useContext(RillContext);
  const isRiR =
    (locals.activeUserToRequest?.intensityMeasure ?? "rpe") !== "rpe";
  const toMeasure = useCallback(
    (value) => convertToRiR(value, !isRiR),
    [isRiR]
  );
  return { isRiR, context: isRiR ? "rir" : undefined, toMeasure };
};

// The translate helper of one section of readinessRate.report: tr(t, "title") reads
// `readinessRate.report.<section>.title`
export const sectionTranslator = (section) => (t, key, options) =>
  t(`readinessRate.report.${section}.${key}`, options);
